import { Controller } from "stimulus";

export default class extends Controller {
  validationOnSendForm(e) {
    e.preventDefault();
    const idNumber = document.getElementsByName("customer[personal_datum_attributes][id_number]");
    const dateOfIssue = document.getElementsByName("customer[personal_datum_attributes][date_of_issue]");
    const dateOfExpiry = document.getElementsByName("customer[personal_datum_attributes][date_of_expiry]");
    const authority = document.getElementsByName("customer[personal_datum_attributes][authority]");
    const alert = document.getElementById("alertForFields");
    const allFormElements = document.getElementsByClassName("inputsForValidation");
    if(idNumber[0].value === "" || dateOfIssue[0].value === "" || dateOfExpiry[0].value === "" || authority[0].value === "") {
      this.invalidInputs(allFormElements);
      alert.classList.remove("d-none");
      document.getElementById("buttonForSubmit").removeAttribute("data-disable-with");
      window.scrollTo({top: 0, behavior: "smooth"});
    } else {
      alert.parentNode.submit();
    }
  }

  invalidInputs(elements) {
    for (let i = 0; i < elements.length; i++) {
      if(elements.item(i).value === "") {
        elements.item(i).classList.add("is-invalid");
      } else {
        elements.item(i).classList.add("is-valid");
        elements.item(i).classList.remove("is-invalid");
      }
    }
  }
}
